export const STATUS_ASSOCIATED_ENTITY_ID = 1;

export function readAssociationId(mePayload) {
  const person = mePayload && mePayload.data;
  if (!person || !person.association || !person.association.id) {
    return null;
  }
  return person.association.id;
}

export function buildPersonMeUrl({ baseURLV2 }) {
  return new URL(`${String(baseURLV2).replace(/\/$/, "")}/api/auth/persons/me`).toString();
}

export function buildStatusAssociatedUrl({
  baseURL,
  language,
  associationId,
  centerCostId,
}) {
  if (!associationId) {
    return "";
  }
  const url = new URL(
    `${String(baseURL).replace(/\/$/, "")}/api/${language}/association/status-associated`
  );
  url.searchParams.set("associationId", String(associationId));
  url.searchParams.set("entityId", String(STATUS_ASSOCIATED_ENTITY_ID));
  if (centerCostId) {
    url.searchParams.set("center_cost_id", String(centerCostId));
  }
  return url.toString();
}
